/**
 * Product Key
 * ------------------------------------------------------------------------------------------
 * Each product has a type. Each type has its own flow, pages etc.
 */
export const PRODUCT_KEYS = [
    // Passes
    'ski',
    'swp',
    'jtp',
    'employee-skipass',
    'unlimited-pass-summer',
    'unlimited-pass-winter',

    // Adventures
    'adventure',
    'guided-tour',
    'swa',

    // First Activities
    'first-flyerglider',
    'first-flyer',
    'first-glider',

    // Sledging
    'eigerrun',
    'pintenfritz',

    // P2P Joch
    'joch',
    'joch-epr',

    // P2P Summer Mountains
    'first',
    'schynige-platte',
    'harder-kulm',
    'kleine-scheidegg',
    'eigergletscher',
    'winteregg-muerren',

    // P2P Generic
    'p2p',

    // Activity Generic
    'activity',

    // Accommodation
    'hotel',

    // Rentals
    'rental-ski',

] as const;

export type ProductKey = typeof PRODUCT_KEYS[number];
